import { Component, OnInit } from "@angular/core";
import { NavbarLoaderService } from "./shared/services/navbar-loader.service";

// Firebase
import { AngularFirestore } from "@angular/fire/firestore";
import "firebase/firestore";
import { Observable } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  title = "makaw-angular";
  itemsNavbar: any[];
  items: Observable<any[]>;

  constructor(
    private navbarLoader: NavbarLoaderService,
    private firestore: AngularFirestore,
    public router: Router
  ) {
    this.items = this.firestore.collection("items").valueChanges();
  }

  ngOnInit(): void {
    this.itemsNavbar = this.navbarLoader.getItemsLoaded();
  }
}
